




















































import { SubContent1 } from '@/components/qrender/types'
import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import { answersDisplay, kpsDisplay } from '../utils'
import { SCRenderMixin } from './SCRenderMixin'

@Component
export default class SCRenderBase extends Mixins(SCRenderMixin) {
  public kpsDisplay = kpsDisplay
  public answersDisplay = answersDisplay
}
